import appSettings from 'wanderu-config';

async function sendEvents(events) {
    const url = _getUrl();

    try {
        navigator.sendBeacon(url, JSON.stringify(events));
    } catch (ex) {
        // swallow the error until WAPI-311 gets done as there are too many issues with this
    }
}

function _getUrl() {
    return `${appSettings.config.wapi.urlRoot}events.json`;
}

export default {
    sendEvents,
};
